//
// 鋼材ミルシート集計表（発注照合版）のページ番号採番。
// 要件定義書 07/06 版 3.2: 直前の明細行と「証明書番号」が同一である場合、単一の連番（1, 2, 3...）ではなく
// 「主番-枝番」（1-1, 1-2...）の形式でカウントアップする（例: 1, 2-1, 2-2, 2-3, 3）。
//
// 採番の単位は**ミルシート 1 枚 = 主番 1 つ**とし、証明書番号の文字列では判定しない。
// 証明書番号のユニークキーは「証明書番号 × 工事名称」（裏書運用で同一番号が複数工事に存在しうる）ため、
// 文字列で連続判定すると別工事の別ミルシートが 1 つの主番に統合され、
// 原本 PDF に同じページ番号が二重に印字されてしまう。
// 主番はそのミルシートの原本 PDF のページ番号としても印字する（02_business_flow.md）。
//

export type SummaryPageNumbering = {
  // 主番（＝そのミルシートの原本 PDF に印字するページ番号）
  mainNumber: number
  // 集計表の明細行ごとに表示するページ番号。
  // 明細 1 行なら枝番なし（'2'）、複数行なら主番-枝番（'2-1', '2-2'...）
  rowLabels: string[]
}

// 印刷順に並べたミルシートの明細行数を受け取り、ミルシートごとの採番を返す。
// 明細が 0 行のミルシート（集計表に行を持たない）にも主番は振る（原本 PDF は出力されるため）
export function assignSummaryPageNumbers(itemCounts: number[]): SummaryPageNumbering[] {
  return itemCounts.map((itemCount, index) => {
    const mainNumber = index + 1
    if (itemCount === 1) {
      return { mainNumber, rowLabels: [`${mainNumber}`] }
    }
    return {
      mainNumber,
      rowLabels: Array.from({ length: itemCount }, (_, branchIndex) => `${mainNumber}-${branchIndex + 1}`),
    }
  })
}
